import { Grid, SelectChangeEvent, useEventCallback } from '@mui/material';
import { FormikErrors, FormikTouched } from 'formik';
import { memo, ReactElement } from 'react';
import PmiTextField from 'shell/components/shared/text-field';
import { FormResponsibleVM } from '.';
import ListTypePractice from 'practice/components/shared/list-type-practice';

interface FormTypeOperationProps {
  disabled?: boolean;
  values?: FormResponsibleVM;
  isEdit?: boolean;
  onChange: (
    key: keyof FormResponsibleVM,
    value: FormResponsibleVM[keyof FormResponsibleVM]
  ) => void;
  errors: FormikErrors<FormResponsibleVM> | undefined;
  touched: FormikTouched<FormResponsibleVM> | undefined;
}

const FormTypeOperationComponent = ({
  disabled,
  values,
  isEdit,
  onChange,
  touched,
  errors,
}: FormTypeOperationProps): ReactElement => {
  const handleListTypePracticeChange = useEventCallback((event: SelectChangeEvent<string>) => {
    onChange('practice', event.target.value);
  });

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12} md={4}>
        <ListTypePractice
          value={values?.practice || ''}
          onChange={handleListTypePracticeChange}
          error={touched?.practice && Boolean(errors?.practice)}
          required
          disabled={disabled || isEdit}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Codice servizio"
          label="Codice servizio *"
          id="service"
          name="service"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.service || ''}
          onChange={(event) => onChange('service', event.target.value)}
          inputProps={{
            maxLength: '4',
          }}
          disabled={disabled || isEdit}
          error={touched?.service && Boolean(errors?.service)}
          helperText={errors?.service}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <PmiTextField
          aria-label="Codice responsabile"
          label="Codice responsabile *"
          id="responsible"
          name="responsible"
          fullWidth
          type="text"
          variant="outlined"
          value={values?.responsible || ''}
          onChange={(event) => onChange('responsible', event.target.value)}
          inputProps={{
            maxLength: '6',
          }}
          disabled={disabled}
          error={touched?.responsible && Boolean(errors?.responsible)}
          helperText={errors?.responsible}
        />
      </Grid>
    </Grid>
  );
};

FormTypeOperationComponent.displayName = 'Form Type operation Page component';

const FormTypeOperation = memo(FormTypeOperationComponent);

export default FormTypeOperation;
